module.exports = __webpack_public_path__ + "img/img_2.fbbfd85e.png";